import { SET_OFFSITE_DATA } from './types';

export const setOffSiteData = (offSiteData) => {
	return {
		type: SET_OFFSITE_DATA,
		payload: offSiteData
	};
};
